let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9azxL")).then(() => parcelRequire('lTK0k'));